export const filterProperties = (object: any, property: string) => {
    if (object.hasOwnProperty(property)) {
        return { [property]: object[property] };
    }

    return object;
}